import { render, staticRenderFns } from "./StudyViewerLayout.vue?vue&type=template&id=792bf8b0&scoped=true&"
import script from "./StudyViewerLayout.vue?vue&type=script&lang=ts&"
export * from "./StudyViewerLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudyViewerLayout.vue?vue&type=style&index=0&id=792bf8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792bf8b0",
  null
  
)

export default component.exports